/**
 * @generated SignedSource<<e9749c207deecec349c96b4ff8e768f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      }
    ],
    "concreteType": "RescheduleResponse",
    "kind": "LinkedField",
    "name": "checkRescheduleStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RescheduleStatusResponseType",
        "kind": "LinkedField",
        "name": "rescheduleStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowReschedule",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rescheduleCharge",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RescheduleStatusCheckQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RescheduleStatusCheckQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "edaabab4b5a800c4acb7cdef3d092f4d",
    "id": null,
    "metadata": {},
    "name": "RescheduleStatusCheckQuery",
    "operationKind": "query",
    "text": "query RescheduleStatusCheckQuery(\n  $bookingId: String\n) {\n  checkRescheduleStatus(bookingId: $bookingId) {\n    rescheduleStatus {\n      allowReschedule\n      rescheduleCharge\n    }\n  }\n}\n"
  }
};
})();

node.hash = "9625b95cf69a56d45f857064cde1b120";

module.exports = node;
